import { type ConversationChannelsResponse } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { CONVERSATION_LIST_PAGE_SIZE } from './constants';

export const shouldExposeConversationListPaginationExperiment = ({
	shouldUsePagination,
	conversationChannelsResponse,
}: {
	shouldUsePagination: boolean;
	conversationChannelsResponse: ConversationChannelsResponse;
}): boolean =>
	shouldUsePagination
		? conversationChannelsResponse.hasNext
		: conversationChannelsResponse.items.length > CONVERSATION_LIST_PAGE_SIZE;
